module.exports = __webpack_public_path__ + "img/ray.67d74cba.png";